'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarGraph = require('./BarGraph');

Object.defineProperty(exports, 'BarGraph', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BarGraph).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Visualizations/index.js
// module id = 663
// module chunks = 0